import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skc-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
